<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0H30V30H0z" transform="translate(-6 -6)" />
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M22 6c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H8c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2h14zm0 1H8c-.513 0-.936.386-.993.883L7 8v14c0 .513.386.936.883.993L8 23h14c.513 0 .936-.386.993-.883L23 22V8c0-.513-.386-.936-.883-.993L22 7zm-2.5 3h.012c.02 0 .041.002.062.005L19.5 10c.036 0 .071.004.105.011l.046.012.04.015c.014.005.027.012.04.019.013.006.025.013.036.02l.035.025c.014.01.027.02.04.033l.012.011.011.013c.012.012.023.025.033.039l-.044-.052c.026.027.05.056.069.087l.02.035.02.041.014.04c.005.015.009.03.012.046l.003.015.003.018.005.052v6.02c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41L19 16.5v-4.794l-8.146 8.148c-.196.195-.512.195-.708 0-.173-.174-.192-.443-.057-.638l.057-.07L18.292 11H13.5c-.245 0-.45-.177-.492-.41L13 10.5c0-.245.177-.45.41-.492L13.5 10h6z"
        transform="translate(-6 -6)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
